import BaseFactory from 'services/sports/default/base-factory';
import Const from 'constants';
import UserAdjustmentsValidatorSinglegameBuilder from './user-adjustments-validator-singlegame-builder';
import UserAdjustmentsValidatorClassicBuilder from './user-adjustments-validator-classic-builder';
import EditedLineupValidatorClassicBuilder from './edited-lineup-validator-classic-builder';
import EditedLineupValidatorSinglegameBuilder from './edited-lineup-validator-singlegame-builder';

const userAdjustmentsValidatorClassesMap = {
    [Const.GAME_TYPE_CLASSIC]: UserAdjustmentsValidatorClassicBuilder,
    [Const.GAME_TYPE_SINGLEGAME]: UserAdjustmentsValidatorSinglegameBuilder,
};

export class UserAdjustmentsValidatorFactory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in userAdjustmentsValidatorClassesMap) {
            return new userAdjustmentsValidatorClassesMap[gameType](params);
        }

        return super.createObj(objectName, params);
    }
}

const editedLineupValidatorClassesMap = {
    [Const.GAME_TYPE_CLASSIC]: EditedLineupValidatorClassicBuilder,
    [Const.GAME_TYPE_SINGLEGAME]: EditedLineupValidatorSinglegameBuilder,
};

export class EditedLineupValidatorFactory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in editedLineupValidatorClassesMap) {
            return new editedLineupValidatorClassesMap[gameType](params);
        }

        throw new Error(`Unknown gameType "${gameType}".`);
    }
}
